import React, {FC, PropsWithChildren, ReactNode} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {IconButton} from '../../../../libs/shared/ui/src/components/buttons/iconButton';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {UserThemeConsumer} from '../../../../libs/shared/ui/src/theme/userThemeConsumer';

/*
 * Props.
 */

export interface SideCalendarsHeaderProps {
  title: ReactNode;
  onBackClick?: () => void;
}

/*
 * Styles.
 */

const StyledHeaderDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px 16px 16px;
  color: ${(p) => p.theme.greys.shade70};
  font-size: ${fontSizes.large};
  font-weight: ${fontWeights.medium};
  padding-top: 8px;
  padding-bottom: 16px;
  font-size: ${fontSizes.medium};
  font-weight: ${fontWeights.semibold};
`;

const StyledContentWrapperDiv = styled.div`
  display: flex;
  align-items: center;
`;

const StyledIconButton = styled(IconButton)`
  transform: rotateZ(180deg);
  padding: 5px;
  margin: 0 5px 0 -8px;
`;

/*
 * Component.
 */

export const SideCalendarsHeader: FC<PropsWithChildren<SideCalendarsHeaderProps>> = (props) => {
  const {title, onBackClick, children} = props;

  return (
    <StyledHeaderDiv>
      <StyledContentWrapperDiv>
        {maybeRenderBackButton(onBackClick)}
        {title}
      </StyledContentWrapperDiv>
      <StyledContentWrapperDiv>{children}</StyledContentWrapperDiv>
    </StyledHeaderDiv>
  );
};

function maybeRenderBackButton(onBackClick: (() => void) | undefined) {
  if (!onBackClick) {
    return null;
  }

  return (
    <UserThemeConsumer>
      {(theme) => (
        <StyledIconButton
          iconName="chevron"
          label={<Trans id="calendar-header-back-btn">Back</Trans>}
          color={theme.greys.shade80}
          hoverColor={theme.greys.shade80}
          onClick={onBackClick}
        />
      )}
    </UserThemeConsumer>
  );
}
